import { Mutation } from "@evergis/react-fetching/es/createMutation";
import { SetLayerParametersPayload } from "@evergis/api";

import { getEqlParams, setEqlParams } from "../../resources/eql";

import { LayerInfo } from "../../interfaces/resourceInfo";

type SetParamsMutation = Mutation<
  { layerName: string; payload: SetLayerParametersPayload },
  { result: void; layerName: string }
>;

export const useLayerParams = (layer?: LayerInfo): [Record<string, string>, SetParamsMutation] => {
  const { data: layerParams } = getEqlParams.use({
    input: layer?.type === "QueryLayerService" ? layer.name : undefined,
    waitInput: true,
  });

  const [setLayerParams] = setEqlParams.use();

  return [layerParams, setLayerParams];
};
